<template>
  <div class="product-reviews-content">
    <div class="add-product-review">
      <h3 class="text-uppercase heading-text-color font-weight-semibold">
        {{ translations.writeReview }}
      </h3>
      <p>{{ translations.howDoYouRateThisProduct }} *</p>

      <form action="#">
        <star-rating
          v-model="rating"
          :star-size="22"
          :increment="1"
          :show-rating="false"
        ></star-rating>

        <!-- End .form-group -->
        <div class="form-group mb-2">
          <label>{{translations.reviews}}</label>
          <textarea
            cols="5"
            rows="6"
            class="form-control form-control-sm"
            v-model="comment"
          ></textarea>
        </div>
        <!-- End .form-group -->
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            v-model="anonymous"
            class="custom-control-input"
            id="anonimus-review"
          />
          <label class="custom-control-label" for="anonimus-review">
            {{ translations.anonymous }}
          </label>
        </div>
        <!-- End .custom-checkbox -->
        <input
          type="button"
          @click.stop.prevent="addReview()"
          class="btn btn-primary"
          :value="translations.submitReview"
        />
      </form>
    </div>
    <!-- End .add-product-review -->

    <div v-for="item in reviews" :key="item.id">
      <div class="entry-author" :class="{ 'if-replied': item.replyComment }">
        <h1><i class="icon-user"></i></h1>
        <div class="author-content">
          <p class="author-name">{{ item.user }}</p>
          <div class="ratings-container">
            <div class="article-ratings">
              <star-rating
                :inline="true"
                :star-size="15"
                :read-only="true"
                :show-rating="false"
                :rating="item.rating"
              />
            </div>
          </div>
          <!-- End rating stars -->
          <p class="review-date">{{ format(item.createdDate) }}</p>
          <p>{{ item.comment }}</p>
        </div>
        <!-- End .author.content -->
      </div>
      <div class="review-reply" v-if="item.replyComment">
        <div class="reply-content">
          <h1><i class="icon-user"></i></h1>
          <div class="author-content">
            <p class="author-name">{{ translations.administrator }}</p>
            <p class="review-date">{{ format(item.replyCommentDate) }}</p>
            <p>{{ item.replyComment }}</p>
          </div>
          <div class="vertical-line"></div>
          <div class="horizontal-line"></div>
        </div>
      </div>
    </div>
    <!-- End .entry-author -->
  </div>
</template>

<script>
import { format } from 'date-fns';
import StarRating from 'vue-star-rating';

import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'ArticleReviews',
  mixins: [translations],
  components: { StarRating },
  data() {
    return {
      anonymous: false,
      comment: '',
      rating: 5,
    };
  },
  computed: {
    reviews() {
      return this.$store.getters.getReviews;
    },
  },
  methods: {
    addReview() {
      api
        .addReview({
          articleId: parseInt(this.$route.params.id, 10),
          rating: this.rating,
          comment: this.comment,
          anonymous: this.anonymous,
        })
        .then((response) => {
          this.comment = '';
          this.$toast(response.data.info);
          this.$store.dispatch('getReviewsForArticle', this.$route.params.id);
        });
    },
    format(dateString) {
      return format(new Date(dateString), 'dd.MM.yyyy H:mm');
    },
  },
};
</script>
<style>
.review-reply {
  border-bottom: 1px solid #ddd;
  margin-bottom: 3rem;
}

.reply-content {
  display: flex;
  margin-bottom: 3rem;
  border: 1px solid #ddd;
  padding: 20px 20px 0 10px;
  margin-left: 150px;
  position: relative;
}
.vertical-line {
  width: 1px;
  height: 60px;
  background: #ddd;
  position: absolute;
  left: -55px;
  top: -20px;
}
.horizontal-line {
  width: 55px;
  height: 1px;
  background: #ddd;
  position: absolute;
  left: -55px;
  top: 39px;
}

.if-replied {
  border-bottom: 0;
  margin-bottom: 0;
}

@media (max-width: 575px) {
  .reply-content {
    margin-left: 110px;
  }
}
</style>
